import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import exclamationIcon from '../../Assets/svg/ExclamationIcon.svg';

export const ExclamationIcon = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={exclamationIcon} ref={ref} {...props} />;
});
